import type React from 'react'
import { useEffect, useRef } from 'react'
import { useIsMounted } from './useIsMounted'

export function useUpdateEffect(
  callback: React.EffectCallback,
  deps: React.DependencyList
) {
  const isMounted = useIsMounted()
  const effectCycleRef = useRef(false)

  useEffect(() => {
    const mounted = isMounted()
    const run = mounted && effectCycleRef.current
    if (run) {
      return callback()
    }
    effectCycleRef.current = true
  }, deps)
}
